// @ts-nocheck
(() => {
  const BREAKPOINT_MOBILE = 768;
  const SWIPER_RETRY_DELAY = 120;
  const SWIPER_MAX_RETRIES = 20;
  const SECTION_SELECTOR = '.best-sellers-section[data-section-id]';
  const ARROW_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M17.031 12.531L9.53104 20.031C9.46136 20.1007 9.37863 20.156 9.28759 20.1937C9.19654 20.2314 9.09896 20.2508 9.00042 20.2508C8.90187 20.2508 8.80429 20.2314 8.71324 20.1937C8.6222 20.156 8.53947 20.1007 8.46979 20.031C8.40011 19.9614 8.34483 19.8786 8.30712 19.7876C8.26941 19.6965 8.25 19.599 8.25 19.5004C8.25 19.4019 8.26941 19.3043 8.30712 19.2132C8.34483 19.1222 8.40011 19.0395 8.46979 18.9698L15.4401 12.0004L8.46979 5.03104C8.32906 4.89031 8.25 4.69944 8.25 4.50042C8.25 4.30139 8.32906 4.11052 8.46979 3.96979C8.61052 3.82906 8.80139 3.75 9.00042 3.75C9.19944 3.75 9.39031 3.82906 9.53104 3.96979L17.031 11.4698C17.1008 11.5394 17.1561 11.6222 17.1938 11.7132C17.2316 11.8043 17.251 11.9019 17.251 12.0004C17.251 12.099 17.2316 12.1966 17.1938 12.2876C17.1561 12.3787 17.1008 12.4614 17.031 12.531Z" fill="#2C2820"/></svg>';

  const bindQuickAddButtons = (section) => {
    const quickAddButtons = section.querySelectorAll('.best-sellers-section__quick-add[data-variant-id]');

    quickAddButtons.forEach((button) => {
      if (button.dataset.quickAddBound === 'true') return;
      button.dataset.quickAddBound = 'true';

      button.addEventListener('click', async () => {
        if (button.disabled) return;

        const variantId = button.dataset.variantId;
        const quantity = Number(button.dataset.quantity || '1') || 1;
        if (!variantId) return;

        button.disabled = true;

        try {
          const payload = {
            items: [{
              id: Number(variantId),
              quantity
            }]
          };

          const cartComponents = document.querySelectorAll('cart-items-component[data-section-id]');
          const sectionIds = Array.from(cartComponents)
            .map((component) => component.dataset.sectionId)
            .filter(Boolean);

          if (sectionIds.length > 0) {
            payload.sections = sectionIds.join(',');
            payload.sections_url = window.location.pathname + window.location.search;
          }

          const cartAddUrl = window.Theme && window.Theme.routes ? window.Theme.routes.cart_add_url : '/cart/add.js';
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(payload)
          });

          const result = await response.json();
          if (result.status) {
            throw new Error(result.description || result.message || 'Add to cart failed');
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: result,
                sourceId: section.dataset.sectionId || 'best-sellers-section',
                data: {
                  source: 'product-form-component',
                  itemCount: quantity,
                  sections: result.sections || {}
                }
              }
            })
          );

          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
            if (trigger && typeof trigger.click === 'function') {
              trigger.click();
            }
          }
        } catch (error) {
          console.error(error);
        } finally {
          button.disabled = false;
        }
      });
    });
  };

  const initSection = (section) => {
    if (section.dataset.bestSellersInitialized === 'true') return;
    section.dataset.bestSellersInitialized = 'true';

    const grid = section.querySelector('[data-best-sellers-swiper]');
    let swiperInstance = null;
    let swiperRetryCount = 0;
    const slides = grid ? grid.querySelectorAll('.best-sellers-section__item') : [];
    let prevArrow = section.querySelector('[data-best-sellers-prev]');
    let nextArrow = section.querySelector('[data-best-sellers-next]');

    if (grid && !prevArrow) {
      prevArrow = document.createElement('button');
      prevArrow.type = 'button';
      prevArrow.className = 'best-sellers-section__mobile-arrow best-sellers-section__mobile-arrow--prev';
      prevArrow.setAttribute('data-best-sellers-prev', '');
      prevArrow.setAttribute('aria-label', 'Previous products');
      prevArrow.innerHTML = ARROW_ICON;
      grid.append(prevArrow);
    }

    if (grid && !nextArrow) {
      nextArrow = document.createElement('button');
      nextArrow.type = 'button';
      nextArrow.className = 'best-sellers-section__mobile-arrow best-sellers-section__mobile-arrow--next';
      nextArrow.setAttribute('data-best-sellers-next', '');
      nextArrow.setAttribute('aria-label', 'Next products');
      nextArrow.innerHTML = ARROW_ICON;
      grid.append(nextArrow);
    }

    bindQuickAddButtons(section);

    const enableNativeScrollFallback = () => {
      grid.classList.add('best-sellers-section__grid--native-scroll');
    };

    const disableNativeScrollFallback = () => {
      grid.classList.remove('best-sellers-section__grid--native-scroll');
    };

    const updateArrowVisibility = () => {
      if (!nextArrow || !prevArrow) return;

      const shouldShowArrow = window.innerWidth <= BREAKPOINT_MOBILE && slides.length > 2;
      if (!shouldShowArrow) {
        nextArrow.classList.add('is-hidden');
        prevArrow.classList.add('is-hidden');
        return;
      }

      if (swiperInstance) {
        prevArrow.classList.toggle('is-hidden', swiperInstance.isBeginning);
        nextArrow.classList.toggle('is-hidden', swiperInstance.isEnd);
        return;
      }

      const maxScrollLeft = Math.max(0, grid.scrollWidth - grid.clientWidth);
      const currentScrollLeft = grid.scrollLeft;
      const atStart = currentScrollLeft <= 2;
      const atEnd = currentScrollLeft >= (maxScrollLeft - 2);

      prevArrow.classList.toggle('is-hidden', atStart);
      nextArrow.classList.toggle('is-hidden', atEnd);
    };

    const slideWidth = () => {
      const firstSlide = slides[0];
      if (!firstSlide) return 0;

      const style = window.getComputedStyle(firstSlide);
      const marginRight = Number.parseFloat(style.marginRight) || 0;
      return firstSlide.getBoundingClientRect().width + marginRight;
    };

    const updateSwiper = () => {
      if (!grid) return;

      if (window.innerWidth <= BREAKPOINT_MOBILE) {
        if (swiperInstance) return;
        if (!window.Swiper) {
          if (swiperRetryCount < SWIPER_MAX_RETRIES) {
            swiperRetryCount += 1;
            window.setTimeout(updateSwiper, SWIPER_RETRY_DELAY);
          } else {
            enableNativeScrollFallback();
          }
          return;
        }

        try {
          swiperInstance = new window.Swiper(grid, {
            slidesPerView: 2.2,
            spaceBetween: 12,
            freeMode: false,
            centeredSlides: false,
            watchOverflow: true,
            resistanceRatio: 0.7,
            breakpoints: {
              520: {
                slidesPerView: 2.2,
                spaceBetween: 12
              },
              680: {
                slidesPerView: 2.2,
                spaceBetween: 12
              }
            }
          });
          swiperInstance.on('slideChange', updateArrowVisibility);
          swiperInstance.on('reachBeginning', updateArrowVisibility);
          swiperInstance.on('reachEnd', updateArrowVisibility);
          disableNativeScrollFallback();
          swiperRetryCount = 0;
        } catch (error) {
          console.error(error);
          enableNativeScrollFallback();
        }
      } else if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
        swiperRetryCount = 0;
        disableNativeScrollFallback();
      } else {
        disableNativeScrollFallback();
      }

      updateArrowVisibility();
    };

    if (prevArrow && prevArrow.dataset.arrowBound !== 'true') {
      prevArrow.dataset.arrowBound = 'true';
      prevArrow.addEventListener('click', () => {
        if (swiperInstance) {
          swiperInstance.slidePrev();
          return;
        }

        if (window.innerWidth > BREAKPOINT_MOBILE) return;

        const offset = slideWidth();
        if (offset > 0) {
          grid.scrollBy({ left: -offset, behavior: 'smooth' });
          window.setTimeout(updateArrowVisibility, 180);
        }
      });
    }

    if (nextArrow && nextArrow.dataset.arrowBound !== 'true') {
      nextArrow.dataset.arrowBound = 'true';
      nextArrow.addEventListener('click', () => {
        if (swiperInstance) {
          swiperInstance.slideNext();
          return;
        }

        if (window.innerWidth > BREAKPOINT_MOBILE) return;

        const offset = slideWidth();
        if (offset > 0) {
          grid.scrollBy({ left: offset, behavior: 'smooth' });
          window.setTimeout(updateArrowVisibility, 180);
        }
      });
    }

    if (grid && grid.dataset.scrollBound !== 'true') {
      grid.dataset.scrollBound = 'true';
      grid.addEventListener('scroll', () => {
        if (!swiperInstance) updateArrowVisibility();
      }, { passive: true });
    }

    window.addEventListener('resize', updateSwiper);
    window.addEventListener('load', updateSwiper, { once: true });
    updateSwiper();
  };

  const init = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initSection(section);
    });
  };

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
